(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'lodash/subtract', '../util/convert'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('lodash/subtract'), require('../util/convert'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.subtract, global.convert);
    global.subtract = mod.exports;
  }
})(this, function (exports, _subtract2, _convert) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = exports.subtract = undefined;

  var _subtract3 = _interopRequireDefault(_subtract2);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  /**
   * Replaces by the subtraction of the former number by the given number.
   * @function
   * @memberof math
   * @param {Object} object The object to modify.
   * @param {Array|string} path The path of the property to set.
   * @param {number} subtrahend The number to subtract.
   * @return {Object} Returns the updated object.
   * @example subtract({ nested: { prop: 2000 } }, 'nested.prop', 336) // => { nested: { prop: 1664 } }
   * @see {@link https://lodash.com/docs#subtract|lodash.subtract} for more information.
   * @since 0.3.0
   */
  var subtract = (0, _convert.convert)(_subtract3.default);
  exports.subtract = subtract;
  exports.default = subtract;
});